// (window, $);
import React, { Fragment, useEffect, useState } from "react";

//router
import { Link } from "react-router-dom";

//alert
import { permissionError } from "../../util/alert";

//server path
import { baseURL } from "../../util/serverPath";

//dayjs
import dayjs from "dayjs";

//redux
import { useDispatch, connect, useSelector } from "react-redux";
import {
  getPendingRequest,
  acceptPendingRequest,
  deleteHostRequest,
} from "../../store/pendingHostRequest/action";

//types
import {
  OPEN_IMAGE_DIALOG,
  OPEN_REQUEST_DIALOG,
  UNSET_ACCEPT_REQUEST_DONE,
} from "../../store/pendingHostRequest/types";

//dialog
import RequestDialog from "../Dialog/pendingHostRequestDialog";

//custom css
import "../../dist/css/style.min.css";
import "../../dist/css/style.css";

//MUI
import { Snackbar, TablePagination } from "@material-ui/core";
import TablePaginationActions from "./TablePagination";
import { Alert } from "@material-ui/lab";
import { OPEN_HOST_DIALOG } from "../../store/host/types";
import ShowImageHostRequest from "../Dialog/ShowImageHostRequest";

const PendingRequestTable = (props) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openSuccess, setOpenSuccess] = useState(false);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const { request, createDone } = useSelector((state) => state.request);
  const hasPermission = useSelector((state) => state.admin.user.flag);

  useEffect(() => {
    props.getPendingRequest();
  }, []);

  useEffect(() => {
    setData(request);
  }, [request]);

  const AcceptRequest = (data) => {
    console.log("data", data);
    // console.log("data", data);
    // dispatch({ type: OPEN_REQUEST_DIALOG, payload: data });
    // props.acceptPendingRequest(data._id);

    const res = {
      agencyId: data?.agencyId?._id,
    };

    props.acceptPendingRequest(res, data._id);
  };

  const handleEdit = (data) => {
    dispatch({ type: OPEN_REQUEST_DIALOG, payload: data });
  };

  useEffect(() => {
    if (createDone) {
      setOpenSuccess(true);
      dispatch({ type: UNSET_ACCEPT_REQUEST_DONE });
    }
  }, [createDone, dispatch]);

  const handleSearch = (e) => {
    const value = e.target.value.toUpperCase();
    if (value) {
      const data = request.filter((data) => {
        return (
          data?.user_id?.name?.toUpperCase()?.indexOf(value) > -1 ||
          data?.user_id?.country?.toUpperCase()?.indexOf(value) > -1 ||
          data?.agencyId?.name?.toUpperCase()?.indexOf(value) > -1
        );
      });
      setData(data);
    } else {
      return setData(request);
    }
  };
  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };

  const handleDeclineHostRequest = (data) => {
    props.deleteHostRequest(data);
  };

  const handelOpenImage = (url) => {
    console.log("url", url);
    window.open(url, "_blank");
  };

  const handleOpenImage = (image) => {
    dispatch({ type: OPEN_IMAGE_DIALOG, payload: image });
  };

  return (
    <Fragment>
      <Snackbar
        open={openSuccess}
        autoHideDuration={3000}
        onClose={handleCloseSuccess}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleCloseSuccess} severity="success">
          <span style={{ color: "#184d47" }}>
            <b>Success!</b> Request Accept successfully.
          </span>
        </Alert>
      </Snackbar>
      <div class="page-breadcrumb">
        <div class="row">
          <div class="col-7 align-self-center">
            <div class="d-flex align-items-center">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb m-0 p-0">
                  <li class="breadcrumb-item">
                    <Link to="/admin/dashboard" class="text-muted">
                      Home
                    </Link>
                  </li>
                  <li
                    class="breadcrumb-item text-muted active"
                    aria-current="page"
                  >
                    Request
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-8 mt-4 float-left">
                    <h3 class="card-title">Pending Host Request from User</h3>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 mt-3 float-right">
                    <form action="">
                      <div class="input-group mb-4 border rounded-pill p-1">
                        <div class="input-group-prepend border-0">
                          <div
                            id="button-addon4"
                            class="btn btn-link text-primary"
                          >
                            <i class="fa fa-search"></i>
                          </div>
                        </div>
                        <input
                          type="search"
                          placeholder="What're you searching for?"
                          aria-describedby="button-addon4"
                          class="form-control bg-none border-0 rounded-pill mr-1"
                          onChange={handleSearch}
                        />
                      </div>
                    </form>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-8 mt-3 float-left mb-0"></div>
                </div>

                <div class="table-responsive">
                  <table
                    id="zero_config"
                    class="table table-striped table-bordered no-wrap"
                  >
                    <thead className="text-center">
                      <tr>
                        <th>video</th>
                        <th>Profile Image</th>
                        <th>New Image</th>
                        <th>Name</th>
                        <th>Host Id</th>
                        <th>Coin</th>
                        <th>Followers</th>
                        <th>Following</th>
                        <th>Country</th>
                        <th>Agency Name</th>
                        <th>Show Image</th>
                        <th>Is Accept</th>
                        <th>Is Decline</th>
                        <th>Action</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {data.length > 0 ? (
                        <Fragment>
                          {(rowsPerPage > 0
                            ? data.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                            : data
                          ).map((data, index) => {
                            console.log("data",data);
                            return (
                              <tr key={index} className="text-center">
                                <td>
                                  {
                                    <video
                                      src={baseURL + "/" + data.video}
                                      width="50px"
                                      height="50px"
                                      alt="video"
                                      controls
                                      className="border border-rounded"
                                    />
                                  }
                                </td>
                                <td>
                                  {
                                    <img
                                      src={data?.user_id?.profilePic}
                                      width="70px"
                                      height="70px"
                                      alt="img"
                                      style={{
                                        objectFit: "contain",
                                        borderRadius: "50%",
                                        border: " 1px solid #808080",
                                      }}
                                      class="mr-3"
                                      onClick={() =>
                                        handelOpenImage(data.user_id.profilePic)
                                      }
                                    />
                                  }
                                </td>
                                <td>
                                  {
                                    <img
                                      src={baseURL + "/" + data.newImage}
                                      width="70px"
                                      height="70px"
                                      alt="img"
                                      style={{
                                        objectFit: "contain",
                                        borderRadius: "50%",
                                        border: " 1px solid #808080",
                                      }}
                                      class="mr-3"
                                      onClick={() =>
                                        handelOpenImage(
                                          baseURL + "/" + data.newImage
                                        )
                                      }
                                    />
                                  }
                                </td>

                                <td style={{ verticalAlign: "middle" }}>
                                  {data?.user_id?.name}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {data?.user_id?.username}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {data?.user_id?.coin}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {data?.user_id?.followers_count}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {data?.user_id?.following_count}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {data?.user_id?.country}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {data?.agencyId ? data.agencyId.name : "-"}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  <button
                                    onClick={() => handleOpenImage(data.user_id.image)}
                                    class="btn waves-effect waves-light btn-warning btn-sm"
                                  >
                                    {" "}
                                    Show Image
                                  </button>
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  <label class="switch">
                                    <input
                                      type="checkbox"
                                      checked={data.isAccepted}
                                      onChange={() => AcceptRequest(data)}
                                    />
                                    <span class="slider">
                                      <p
                                        style={{
                                          fontSize: 12,
                                          marginLeft: `${
                                            data.isAccepted ? "5px" : "33px"
                                          }`,
                                          color: "white",
                                          marginTop: "6px",
                                        }}
                                      >
                                        {data.isAccepted ? "Yes" : "No"}
                                      </p>
                                    </span>
                                  </label>
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  <button
                                    type="button"
                                    class="btn waves-effect waves-light btn-danger btn-sm"
                                    data-toggle="modal"
                                    style={{ borderRadius: 5 }}
                                    onClick={() =>
                                      handleDeclineHostRequest(data._id)
                                    }
                                  >
                                    <i class="fas fa-trash"></i> Decline
                                  </button>
                                </td>

                                <td style={{ verticalAlign: "middle" }}>
                                  <a
                                    href={() => false}
                                    class="ml-3"
                                    onClick={() => handleEdit(data)}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <i class="fas fa-edit text-primary mr-3"></i>
                                  </a>
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {dayjs(data.createdAt).format("DD MMM, YYYY")}
                                </td>
                              </tr>
                            );
                          })}
                        </Fragment>
                      ) : (
                        <tr>
                          <td colSpan="13" align="center">
                            Nothing to show!!
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot className="text-center">
                      <tr>
                        <th>video</th>
                        <th>Profile Image</th>
                        <th>New Image</th>
                        <th>Name</th>
                        <th>Host Id</th>
                        <th>Coin</th>
                        <th>Followers</th>
                        <th>Following</th>
                        <th>Country</th>
                        <th>Agency Name</th>
                        <th>Show Image</th>
                        <th>Is Accept</th>
                        <th>Is Decline</th>
                        <th>Action</th>
                        <th>Created At</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div class="py-2">
                  <TablePagination
                    id="pagination"
                    component="div"
                    rowsPerPageOptions={[
                      5,
                      10,
                      25,
                      100,
                      { label: "All", value: -1 },
                    ]}
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { "aria-label": "rows per page" },
                      native: true,
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RequestDialog />
      <ShowImageHostRequest />
    </Fragment>
  );
};

export default connect(null, {
  getPendingRequest,
  acceptPendingRequest,
  deleteHostRequest,
})(PendingRequestTable);
